import { getGLBData } from '@proxies/getGLBData'
import { useAppStore } from '@store'
import { GLBData } from '@types'

// Sistema de caché global para GLB
const glbCache = new Map<string, any>()

/**
 * Limpia el caché de GLB. Útil cuando cambias de API para evitar usar datos de la API anterior.
 */
export function clearGLBCache() {
  glbCache.clear()
}

// Escuchar cambios en la URL de la API para limpiar el caché
if (typeof window !== 'undefined') {
  window.addEventListener('apiUrlChanged', () => {
    clearGLBCache()
  })
}

export async function getGLB(
  glbInScene: Record<string, any>,
  catalogID: string,
  realCatalogID?: string,
) {
  // Si ya está en caché, lo devolvemos directamente
  if (glbCache.has(catalogID)) {
    return glbCache.get(catalogID)
  }

  let glbData
  if (glbInScene.has(catalogID)) {
    const sceneGLBData = useAppStore.getState().sceneGLB.get(catalogID)
    if (!sceneGLBData) {
      console.error('GLB data not found in scene for catalogID:', catalogID)
      return null
    }
    glbData = sceneGLBData.glbData
  } else {
    glbData = await getGLBData(catalogID, realCatalogID)
  }

  // Guardamos en caché si existe
  if (glbData) {
    glbCache.set(catalogID, glbData)
  }

  return glbData as GLBData
}
